export default function InvoiceFinancingIcon() {
  return (
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M88.5418 91.6667H11.4585C9.75016 91.6667 8.3335 90.25 8.3335 88.5417C8.3335 86.8333 9.75016 85.4167 11.4585 85.4167H88.5418C90.2502 85.4167 91.6668 86.8333 91.6668 88.5417C91.6668 90.25 90.2502 91.6667 88.5418 91.6667Z"
        fill="#FDFDFD"
      />
      <path
        opacity="0.4"
        d="M85.7917 57.0833L55.6667 87.2083C49.75 93.125 40.2083 93.125 34.3333 87.25L15.125 68.0417L66.625 16.5417L85.8333 35.75C91.7083 41.625 91.7083 51.1667 85.7917 57.0833Z"
        fill="#FDFDFD"
      />
      <path
        d="M66.625 16.5417L15.0833 68.0417L11.2917 64.25C5.41668 58.375 5.41668 48.8333 11.3333 42.9167L41.4583 12.7917C47.375 6.87499 56.9167 6.87499 62.7917 12.75L66.625 16.5417Z"
        fill="#FDFDFD"
      />
      <path
        d="M53.7083 73.3333L48.0833 78.9583C46.9167 80.125 45.0417 80.125 43.875 78.9583C42.7083 77.7917 42.7083 75.9167 43.875 74.75L49.5 69.125C50.6667 67.9583 52.5417 67.9583 53.7083 69.125C54.875 70.2917 54.875 72.1667 53.7083 73.3333Z"
        fill="#FDFDFD"
      />
      <path
        d="M71.9582 55.0833L60.7498 66.2917C59.5832 67.4583 57.7082 67.4583 56.5415 66.2917C55.3748 65.125 55.3748 63.25 56.5415 62.0833L67.7498 50.875C68.9165 49.7083 70.7915 49.7083 71.9582 50.875C73.0832 52.0417 73.0832 53.9167 71.9582 55.0833Z"
        fill="#FDFDFD"
      />
    </svg>
  );
}
